// Generated from https://speed.cloudflare.com/locations — Cloudflare's own list of data centers.
// Format: [IATA, lat, lon, country (ISO-3166 alpha-2), region, city]
export type ColoRegion = "AP" | "NA" | "EU" | "SA" | "AF" | "ME" | "OC";
export type ColoRow = readonly [string, number, number, string, ColoRegion, string];

export const COLO_ROWS: readonly ColoRow[] = [
  ["AAE", 36.822, 7.809, "DZ", "AF", "Annabah"],
  ["ABJ", 5.261, -3.926, "CI", "AF", "Abidjan"],
  ["ABQ", 35.04, -106.609, "US", "NA", "Albuquerque"],
  ["ACC", 5.605, -0.167, "GH", "AF", "Accra"],
  ["ADB", 38.292, 27.157, "TR", "EU", "Izmir"],
  ["ADD", 8.978, 38.799, "ET", "AF", "Addis Ababa"],
  ["ADL", -34.945, 138.531, "AU", "OC", "Adelaide"],
  ["AGR", 27.156, 77.961, "IN", "AP", ""],
  ["AIP", 31.434, 75.759, "IN", "AP", ""],
  ["AKL", -37.008, 174.792, "NZ", "OC", "Auckland"],
  ["AKX", 50.246, 57.207, "KZ", "EU", "Aktyubinsk"],
  ["ALA", 43.352, 77.04, "KZ", "EU", "Almaty"],
  ["ALG", 36.691, 3.215, "DZ", "AF", "Algiers"],
  ["AMD", 23.077, 72.635, "IN", "AP", "Ahmedabad"],
  ["AMM", 31.723, 35.993, "JO", "ME", "Amman"],
  ["AMS", 52.309, 4.764, "NL", "EU", "Amsterdam"],
  ["ANC", 61.174, -149.996, "US", "NA", "Anchorage"],
  ["ARI", -18.348, -70.339, "CL", "SA", "Arica"],
  ["ARN", 59.652, 17.919, "SE", "EU", "Stockholm"],
  ["ARU", -21.141, -50.425, "BR", "SA", "Aracatuba"],
  ["ASK", 6.903, -5.366, "CI", "AF", "Yamoussoukro"],
  ["ASU", -25.24, -57.52, "PY", "SA", "Asuncion"],
  ["ATH", 37.936, 23.945, "GR", "EU", "Athens"],
  ["ATL", 33.637, -84.428, "US", "NA", "Atlanta"],
  ["AUS", 30.195, -97.67, "US", "NA", "Austin"],
  ["BAH", 26.271, 50.634, "BH", "ME", "Manama"],
  ["BAQ", 10.89, -74.781, "CO", "SA", "Barranquilla"],
  ["BBI", 20.244, 85.818, "IN", "AP", "Bhubaneswar"],
  ["BCN", 41.297, 2.078, "ES", "EU", "Barcelona"],
  ["BDQ", 22.336, 73.226, "IN", "AP", "Vadodara"],
  ["BEG", 44.818, 20.309, "RS", "EU", "Belgrad"],
  ["BEL", -1.379, -48.476, "BR", "SA", "Belem"],
  ["BEY", 33.821, 35.488, "LB", "ME", "Beirut"],
  ["BGI", 13.075, -59.492, "BB", "NA", "Bridgetown"],
  ["BGR", 44.807, -68.828, "US", "NA", "Bangor"],
  ["BGW", 33.263, 44.235, "IQ", "ME", "Baghdad"],
  ["BKK", 13.681, 100.747, "TH", "AP", "Bangkok"],
  ["BLR", 13.198, 77.706, "IN", "AP", "Bangalore"],
  ["BNA", 36.124, -86.678, "US", "NA", "Nashville"],
  ["BNE", -27.384, 153.117, "AU", "OC", "Brisbane"],
  ["BOD", 44.828, -0.716, "FR", "EU", "Bordeaux/Merignac"],
  ["BOG", 4.702, -74.147, "CO", "SA", "Bogota"],
  ["BOM", 19.089, 72.868, "IN", "AP", "Mumbai"],
  ["BOS", 42.364, -71.005, "US", "NA", "Boston"],
  ["BRU", 50.901, 4.484, "BE", "EU", "Brussels"],
  ["BSB", -15.869, -47.921, "BR", "SA", "Brasilia"],
  ["BSR", 30.549, 47.662, "IQ", "ME", "Basrah"],
  ["BTS", 48.17, 17.213, "SK", "EU", "Bratislava"],
  ["BUD", 47.437, 19.256, "HU", "EU", "Budapest"],
  ["BUF", 42.94, -78.732, "US", "NA", "Buffalo"],
  ["BWN", 4.944, 114.928, "BN", "AP", "Bandar Seri Begawan"],
  ["CAI", 30.122, 31.406, "EG", "AF", "Cairo"],
  ["CAW", -21.698, -41.302, "BR", "SA", "Campos Dos Goytacazes"],
  ["CBR", -35.307, 149.195, "AU", "OC", "Canberra"],
  ["CCU", 22.655, 88.447, "IN", "AP", "Kolkata"],
  ["CDG", 49.013, 2.55, "FR", "EU", "Paris"],
  ["CEB", 10.307, 123.979, "PH", "AP", "Lapu-Lapu City"],
  ["CFC", -26.776, -51.013, "BR", "SA", "Caçador"],
  ["CGB", -15.653, -56.117, "BR", "SA", "Cuiaba"],
  ["CGK", -6.126, 106.656, "ID", "AP", "Jakarta"],
  ["CGP", 22.25, 91.813, "BD", "AP", "Chittagong"],
  ["CGY", 8.416, 124.611, "PH", "AP", "Cagayan De Oro City"],
  ["CHC", -43.489, 172.532, "NZ", "OC", "Christchurch"],
  ["CJB", 11.03, 77.043, "IN", "AP", "Coimbatore"],
  ["CLE", 41.412, -81.85, "US", "NA", "Cleveland"],
  ["CLO", 3.543, -76.382, "CO", "SA", "Cali"],
  ["CLT", 35.214, -80.943, "US", "NA", "Charlotte"],
  ["CMB", 7.181, 79.884, "LK", "AP", "Colombo"],
  ["CMH", 39.998, -82.892, "US", "NA", "Columbus"],
  ["CNF", -19.624, -43.972, "BR", "SA", "Belo Horizonte"],
  ["CNN", 11.92, 75.55, "IN", "AP", "Mattanur"],
  ["CNX", 18.767, 98.963, "TH", "AP", "Chiang Mai"],
  ["COK", 10.152, 76.402, "IN", "AP", "Cochin"],
  ["COR", -31.324, -64.208, "AR", "SA", "Cordoba"],
  ["CPH", 55.618, 12.656, "DK", "EU", "Copenhagen"],
  ["CPT", -33.965, 18.602, "ZA", "AF", "Cape Town"],
  ["CRK", 15.186, 120.56, "PH", "AP", "Mabalacat"],
  ["CVG", 39.049, -84.668, "US", "NA", "Hebron"],
  ["CWB", -25.529, -49.176, "BR", "SA", "Curitiba"],
  ["CZL", 36.276, 6.62, "DZ", "AF", "Constantine"],
  ["DAC", 23.843, 90.398, "BD", "AP", "Dhaka"],
  ["DAD", 16.044, 108.199, "VN", "AP", "Da Nang"],
  ["DAR", -6.878, 39.203, "TZ", "AF", "Dar es Salaam"],
  ["DEL", 28.567, 77.103, "IN", "AP", "New Delhi"],
  ["DEN", 39.862, -104.673, "US", "NA", "Denver"],
  ["DFW", 32.897, -97.038, "US", "NA", "Dallas-Fort Worth"],
  ["DKR", 14.74, -17.49, "SN", "AF", "Dakar"],
  ["DLA", 4.006, 9.719, "CM", "AF", "Douala"],
  ["DME", 55.409, 37.906, "RU", "EU", "Moscow"],
  ["DMM", 26.471, 49.798, "SA", "ME", "Ad Dammam"],
  ["DOH", 25.261, 51.614, "QA", "ME", "Doha"],
  ["DPS", -8.748, 115.167, "ID", "AP", "Denpasar-Bali Island"],
  ["DTW", 42.212, -83.353, "US", "NA", "Detroit"],
  ["DUB", 53.421, -6.27, "IE", "EU", "Dublin"],
  ["DUR", -29.614, 31.12, "ZA", "AF", "Durban"],
  ["DUS", 51.29, 6.767, "DE", "EU", "Dusseldorf"],
  ["DXB", 25.253, 55.364, "AE", "ME", "Dubai"],
  ["DYU", 38.543, 68.825, "TJ", "AP", "Dushanbe"],
  ["EBB", 0.042, 32.444, "UG", "AF", "Kampala"],
  ["EBL", 36.238, 43.963, "IQ", "ME", "Arbil"],
  ["EVN", 40.147, 44.396, "AM", "ME", "Yerevan"],
  ["EWR", 40.693, -74.169, "US", "NA", "Newark"],
  ["EZE", -34.822, -58.536, "AR", "SA", "Ezeiza"],
  ["FCO", 41.805, 12.251, "IT", "EU", "Rome"],
  ["FIH", -4.386, 15.445, "CD", "AF", "Kinshasa"],
  ["FLN", -27.67, -48.553, "BR", "SA", "Florianopolis"],
  ["FOR", -3.776, -38.533, "BR", "SA", "Fortaleza"],
  ["FRA", 50.026, 8.543, "DE", "EU", "Frankfurt-am-Main"],
  ["FRU", 43.061, 74.478, "KG", "AP", "Bishkek"],
  ["FSD", 43.582, -96.742, "US", "NA", "Sioux Falls"],
  ["FUK", 33.586, 130.451, "JP", "AP", "Fukuoka"],
  ["GBE", -24.555, 25.918, "BW", "AF", "Gaborone"],
  ["GDL", 20.522, -103.311, "MX", "NA", "Guadalajara"],
  ["GEO", 6.499, -58.254, "GY", "SA", "Georgetown"],
  ["GIG", -22.81, -43.251, "BR", "SA", "Rio De Janeiro"],
  ["GND", 12.004, -61.786, "GD", "SA", "Saint George's"],
  ["GOT", 57.663, 12.28, "SE", "EU", "Gothenburg"],
  ["GRU", -23.436, -46.473, "BR", "SA", "Sao Paulo"],
  ["GUA", 14.583, -90.527, "GT", "NA", "Guatemala City"],
  ["GUM", 13.483, 144.796, "GU", "AP", "Hagatna"],
  ["GVA", 46.238, 6.109, "CH", "EU", "Geneva"],
  ["GYD", 40.467, 50.047, "AZ", "ME", "Baku"],
  ["GYE", -2.157, -79.884, "EC", "SA", "Guayaquil"],
  ["GYN", -16.632, -49.221, "BR", "SA", "Goiania"],
  ["HAM", 53.63, 9.988, "DE", "EU", "Hamburg"],
  ["HAN", 21.221, 105.807, "VN", "AP", "Hanoi"],
  ["HBA", -42.836, 147.51, "AU", "OC", "Hobart"],
  ["HEL", 60.317, 24.963, "FI", "EU", "Helsinki"],
  ["HFA", 32.809, 35.043, "IL", "ME", "Haifa"],
  ["HKG", 22.309, 113.915, "HK", "AP", "Hong Kong"],
  ["HNL", 21.319, -157.922, "US", "NA", "Honolulu"],
  ["HRE", -17.932, 31.093, "ZW", "AF", "Harare"],
  ["HYD", 17.231, 78.43, "IN", "AP", "Hyderabad"],
  ["IAD", 38.944, -77.456, "US", "NA", "Dulles"],
  ["IAH", 29.984, -95.341, "US", "NA", "Houston"],
  ["ICN", 37.469, 126.451, "KR", "AP", "Seoul"],
  ["IND", 39.717, -86.294, "US", "NA", "Indianapolis"],
  ["ISB", 33.617, 73.099, "PK", "AP", "Islamabad"],
  ["IST", 41.262, 28.728, "TR", "EU", "Arnavutkoy"],
  ["ISU", 35.562, 45.317, "IQ", "ME", "Sulaymaniyah"],
  ["IXC", 30.674, 76.788, "IN", "AP", "Chandigarh"],
  ["JAX", 30.494, -81.688, "US", "NA", "Jacksonville"],
  ["JDO", -7.219, -39.27, "BR", "SA", "Juazeiro Do Norte"],
  ["JED", 21.68, 39.157, "SA", "ME", "Jeddah"],
  ["JHB", 1.641, 103.67, "MY", "AP", "Senai"],
  ["JIB", 11.547, 43.16, "DJ", "AF", "Djibouti City"],
  ["JNB", -26.133, 28.25, "ZA", "AF", "Johannesburg"],
  ["JOG", -7.788, 110.432, "ID", "AP", "Yogyakarta-Java Island"],
  ["JOI", -26.225, -48.797, "BR", "SA", "Joinville"],
  ["JRG", 21.913, 84.05, "IN", "AP", "Jharsuguda"],
  ["KBP", 50.345, 30.895, "UA", "EU", "Kiev"],
  ["KCH", 1.485, 110.347, "MY", "AP", "Kuching"],
  ["KEF", 63.985, -22.606, "IS", "EU", "Reykjavik"],
  ["KGL", -1.969, 30.14, "RW", "AF", "Kigali"],
  ["KHH", 22.577, 120.35, "TW", "AP", "Kaohsiung City"],
  ["KHI", 24.907, 67.161, "PK", "AP", "Karachi"],
  ["KIN", 17.936, -76.787, "JM", "NA", "Kingston"],
  ["KIX", 34.427, 135.244, "JP", "AP", "Osaka"],
  ["KNU", 26.399, 80.427, "IN", "AP", "Kanpur"],
  ["KTM", 27.697, 85.359, "NP", "AP", "Kathmandu"],
  ["KUL", 2.746, 101.71, "MY", "AP", "Kuala Lumpur"],
  ["KWI", 29.227, 47.969, "KW", "ME", "Kuwait City"],
  ["LAD", -8.858, 13.231, "AO", "AF", "Luanda"],
  ["LAS", 36.08, -115.152, "US", "NA", "Las Vegas"],
  ["LAX", 33.943, -118.408, "US", "NA", "Los Angeles"],
  ["LCA", 34.875, 33.625, "CY", "EU", "Larnarca"],
  ["LED", 59.8, 30.263, "RU", "EU", "St. Petersburg"],
  ["LHE", 31.522, 74.404, "PK", "AP", "Lahore"],
  ["LHR", 51.471, -0.462, "GB", "EU", "London"],
  ["LIM", -12.022, -77.114, "PE", "SA", "Lima"],
  ["LIS", 38.781, -9.136, "PT", "EU", "Lisbon"],
  ["LJU", 46.224, 14.458, "SI", "EU", "Ljubljana"],
  ["LLK", 38.746, 48.818, "AZ", "ME", "Lankaran"],
  ["LLW", -13.789, 33.781, "MW", "AF", "Lilongwe"],
  ["LOS", 6.577, 3.321, "NG", "AF", "Lagos"],
  ["LPB", -16.513, -68.192, "BO", "SA", "La Paz / El Alto"],
  ["LUH", 30.855, 75.953, "IN", "AP", ""],
  ["LUN", -15.331, 28.453, "ZM", "AF", "Lusaka"],
  ["LUX", 49.627, 6.212, "LU", "EU", "Luxembourg"],
  ["LYS", 45.726, 5.091, "FR", "EU", "Lyon"],
  ["MAA", 12.99, 80.169, "IN", "AP", "Chennai"],
  ["MAD", 40.494, -3.567, "ES", "EU", "Madrid"],
  ["MAN", 53.354, -2.275, "GB", "EU", "Manchester"],
  ["MAO", -3.039, -60.05, "BR", "SA", "Manaus"],
  ["MBA", -4.035, 39.594, "KE", "AF", "Mombasa"],
  ["MCI", 39.298, -94.714, "US", "NA", "Kansas City"],
  ["MCT", 23.593, 58.284, "OM", "ME", "Muscat"],
  ["MDE", 6.165, -75.423, "CO", "SA", "Rionegro"],
  ["MEL", -37.673, 144.843, "AU", "OC", "Melbourne"],
  ["MEM", 35.042, -89.977, "US", "NA", "Memphis"],
  ["MEX", 19.436, -99.072, "MX", "NA", "Mexico City"],
  ["MFM", 22.15, 113.592, "MO", "AP", "Taipa"],
  ["MIA", 25.793, -80.291, "US", "NA", "Miami"],
  ["MLA", 35.857, 14.477, "MT", "EU", "Luqa"],
  ["MLE", 4.192, 73.529, "MV", "AP", "Male"],
  ["MLG", -7.927, 112.715, "ID", "AP", "Malang-Java Island"],
  ["MNL", 14.509, 121.02, "PH", "AP", "Manila"],
  ["MPM", -25.921, 32.573, "MZ", "AF", "Maputo"],
  ["MRS", 43.439, 5.221, "FR", "EU", "Marseille"],
  ["MRU", -20.43, 57.684, "MU", "AF", "Port Louis"],
  ["MSP", 44.882, -93.222, "US", "NA", "Minneapolis"],
  ["MSQ", 53.883, 28.031, "BY", "EU", "Minsk"],
  ["MUC", 48.354, 11.786, "DE", "EU", "Munich"],
  ["MXP", 45.631, 8.728, "IT", "EU", "Milan"],
  ["NAG", 21.092, 79.047, "IN", "AP", "Naqpur"],
  ["NBO", -1.319, 36.928, "KE", "AF", "Nairobi"],
  ["NJF", 31.99, 44.404, "IQ", "ME", "Najaf"],
  ["NOU", -22.015, 166.213, "NC", "OC", "Noumea"],
  ["NQN", -38.949, -68.156, "AR", "SA", "Neuquen"],
  ["NQZ", 51.022, 71.467, "KZ", "AP", "Astana"],
  ["NRT", 35.765, 140.386, "JP", "AP", "Tokyo"],
  ["NVT", -26.88, -48.651, "BR", "SA", "Navegantes"],
  ["OKA", 26.196, 127.646, "JP", "AP", "Naha"],
  ["OKC", 35.393, -97.601, "US", "NA", "Oklahoma City"],
  ["OMA", 41.303, -95.894, "US", "NA", "Omaha"],
  ["ORD", 41.979, -87.905, "US", "NA", "Chicago"],
  ["ORF", 36.895, -76.201, "US", "NA", "Norfolk"],
  ["ORN", 35.624, -0.621, "DZ", "AF", "Oran"],
  ["OSL", 60.194, 11.1, "NO", "EU", "Oslo"],
  ["OTP", 44.572, 26.102, "RO", "EU", "Bucharest"],
  ["OUA", 12.353, -1.512, "BF", "AF", "Ouagadougou"],
  ["PAT", 25.591, 85.088, "IN", "AP", "Patna"],
  ["PBH", 27.403, 89.425, "BT", "AP", "Paro"],
  ["PBM", 5.453, -55.188, "SR", "SA", "Zandery"],
  ["PDX", 45.589, -122.598, "US", "NA", "Portland"],
  ["PER", -31.94, 115.967, "AU", "OC", "Perth"],
  ["PHL", 39.872, -75.241, "US", "NA", "Philadelphia"],
  ["PHX", 33.434, -112.012, "US", "NA", "Phoenix"],
  ["PIT", 40.492, -80.233, "US", "NA", "Pittsburgh"],
  ["PMO", 38.176, 13.091, "IT", "EU", "Palermo"],
  ["PMW", -10.291, -48.357, "BR", "SA", "Palmas"],
  ["PNH", 11.547, 104.844, "KH", "AP", "Phnom Penh"],
  ["PNQ", 18.582, 73.92, "IN", "AP", "Pune"],
  ["POA", -29.994, -51.171, "BR", "SA", "Porto Alegre"],
  ["POS", 10.595, -61.337, "TT", "SA", "Port of Spain"],
  ["PPT", -17.554, -149.607, "PF", "OC", "Papeete"],
  ["PRG", 50.101, 14.26, "CZ", "EU", "Prague"],
  ["PTY", 9.071, -79.383, "PA", "SA", "Tocumen"],
  ["QRO", 20.617, -100.186, "MX", "NA", "Queretaro"],
  ["QWJ", -22.738, -47.334, "BR", "SA", "Americana"],
  ["RAO", -21.136, -47.777, "BR", "SA", "Ribeirao Preto"],
  ["RDU", 35.878, -78.787, "US", "NA", "Raleigh/Durham"],
  ["REC", -8.126, -34.924, "BR", "SA", "Recife"],
  ["RIC", 37.505, -77.32, "US", "NA", "Richmond"],
  ["RIX", 56.924, 23.971, "LV", "EU", "Riga"],
  ["RUH", 24.958, 46.699, "SA", "ME", "Riyadh"],
  ["RUN", -20.887, 55.51, "RE", "AF", "St Denis"],
  ["SAN", 32.734, -117.19, "US", "NA", "San Diego"],
  ["SAP", 15.453, -87.924, "HN", "SA", "La Mesa"],
  ["SAT", 29.534, -98.47, "US", "NA", "San Antonio"],
  ["SCL", -33.393, -70.786, "CL", "SA", "Santiago"],
  ["SDQ", 18.43, -69.669, "DO", "NA", "Santo Domingo"],
  ["SEA", 47.449, -122.309, "US", "NA", "Seattle"],
  ["SFO", 37.619, -122.375, "US", "NA", "San Francisco"],
  ["SGN", 10.819, 106.652, "VN", "AP", "Ho Chi Minh City"],
  ["SIN", 1.35, 103.994, "SG", "AP", "Singapore"],
  ["SJC", 37.363, -121.929, "US", "NA", "San Jose"],
  ["SJK", -23.229, -45.861, "BR", "SA", "Sao Jose Dos Campos"],
  ["SJO", 9.994, -84.209, "CR", "SA", "San Jose"],
  ["SJP", -20.817, -49.407, "BR", "SA", "Sao Jose Do Rio Preto"],
  ["SJU", 18.439, -66.002, "PR", "NA", "San Juan"],
  ["SKG", 40.52, 22.971, "GR", "EU", "Thessaloniki"],
  ["SKP", 41.962, 21.621, "MK", "EU", "Skopje"],
  ["SLC", 40.788, -111.978, "US", "NA", "Salt Lake City"],
  ["SMF", 38.695, -121.591, "US", "NA", "Sacramento"],
  ["SOD", -23.478, -47.49, "BR", "SA", "Sorocaba"],
  ["SOF", 42.697, 23.411, "BG", "EU", "Sofia"],
  ["SSA", -12.068, -45.711, "BR", "SA", "Salvador"],
  ["STI", 19.406, -70.605, "DO", "NA", "Santiago"],
  ["STL", 38.749, -90.37, "US", "NA", "St Louis"],
  ["STR", 48.69, 9.222, "DE", "EU", "Stuttgart"],
  ["SUV", -18.043, 178.559, "FJ", "OC", "Nausori"],
  ["SYD", -33.946, 151.177, "AU", "OC", "Sydney"],
  ["TBS", 41.669, 44.955, "GE", "EU", "Tbilisi"],
  ["TGU", 14.061, -87.217, "HN", "SA", "Tegucigalpa"],
  ["TIA", 41.415, 19.721, "AL", "EU", "Tirana"],
  ["TLH", 30.396, -84.35, "US", "NA", "Tallahassee"],
  ["TLL", 59.413, 24.833, "EE", "EU", "Tallinn"],
  ["TLV", 32.011, 34.887, "IL", "ME", "Tel Aviv"],
  ["TNR", -18.797, 47.479, "MG", "AF", "Antananarivo"],
  ["TPA", 27.976, -82.533, "US", "NA", "Tampa"],
  ["TPE", 25.078, 121.233, "TW", "AP", "Taipei"],
  ["TUN", 36.851, 10.227, "TN", "AF", "Tunis"],
  ["TXL", 52.56, 13.288, "DE", "EU", "Berlin"],
  ["UDI", -18.884, -48.225, "BR", "SA", "Uberlandia"],
  ["UDR", 24.618, 73.896, "IN", "AP", "Udaipur"],
  ["UIO", -0.129, -78.358, "EC", "SA", "Quito"],
  ["ULN", 47.843, 106.767, "MN", "AP", "Ulan Bator"],
  ["URT", 9.133, 99.136, "TH", "AP", "Surat Thani"],
  ["VCP", -23.007, -47.134, "BR", "SA", "Campinas"],
  ["VIE", 48.11, 16.57, "AT", "EU", "Vienna"],
  ["VIX", -20.258, -40.286, "BR", "SA", "Vitoria"],
  ["VNO", 54.634, 25.286, "LT", "EU", "Vilnius"],
  ["VTE", 17.988, 102.563, "LA", "AP", "Vientiane"],
  ["WAW", 52.166, 20.967, "PL", "EU", "Warsaw"],
  ["WDH", -22.48, 17.471, "NA", "AF", "Windhoek"],
  ["WLG", -41.327, 174.805, "NZ", "OC", "Wellington"],
  ["WRO", 51.103, 16.886, "PL", "EU", "Wroclaw"],
  ["XAP", -27.134, -52.657, "BR", "SA", "Chapeco"],
  ["XNH", 30.936, 46.09, "IQ", "ME", "Nasiriyah"],
  ["YHZ", 44.881, -63.509, "CA", "NA", "Halifax"],
  ["YUL", 45.471, -73.741, "CA", "NA", "Montreal"],
  ["YVR", 49.194, -123.184, "CA", "NA", "Vancouver"],
  ["YWG", 49.91, -97.24, "CA", "NA", "Winnipeg"],
  ["YXE", 52.171, -106.7, "CA", "NA", "Saskatoon"],
  ["YYC", 51.114, -114.02, "CA", "NA", "Calgary"],
  ["YYZ", 43.677, -79.631, "CA", "NA", "Toronto"],
  ["ZAG", 45.743, 16.069, "HR", "EU", "Zagreb"],
  ["ZDM", 32.272, 35.019, "PS", "ME", "Ramallah"],
  ["ZRH", 47.465, 8.549, "CH", "EU", "Zurich"],
];
